/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["table[_ngcontent-%COMP%]{margin-top:0;width:100%;height:100%}.fixed-table[_ngcontent-%COMP%]{table-layout:fixed}.label-table[_ngcontent-%COMP%]{background:none!important;border:none!important}.label-table[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{border:none}table.title[_ngcontent-%COMP%]{padding:.5rem;font-size:16px;height:100%}table.title[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{font-weight:700}.container[_ngcontent-%COMP%]{max-height:20rem;overflow-y:auto}"];
export { styles as styles };

